import { render, staticRenderFns } from "./TeacherMotivationPage.vue?vue&type=template&id=1eefc5b7&"
import script from "./TeacherMotivationPage.vue?vue&type=script&lang=ts&"
export * from "./TeacherMotivationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports